var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames, entityLangPath } from '@shapeable/utils';
import { useActiveLang } from '../hooks/use-active-lang';
import { useEntity } from '../hooks/use-entity';
import { useSite } from '../hooks/use-site';
import { MenuItem } from '../elements/menu-item';
import { TextBubble } from '../elements/text-bubble';
import { includes, template } from 'lodash';
import { SiteMenuTitle } from './site-menu-title';
import { useLang } from '../hooks/use-lang';
var cls = classNames('lang-menu');
export var LangMenuDefaultProps = {
  showTitle: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    font-size: 1em;\n  "], ["\n    width: 100%;\n    font-size: 1em;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "], ["\n    border-bottom: 1px dashed #333;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  "])))
});
var TextBubbleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Item: styled(MenuItem)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  TextBubble: styled(TextBubble)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), TextBubbleStyles)
};
/* @ts-ignore */
export var LangMenu = React.forwardRef(function (props, ref) {
  var className = props.className,
    onItemClick = props.onItemClick,
    showTitle = props.showTitle;
  var activeLang = useActiveLang();
  var site = useSite();
  var t = useLang();
  var languages = site.languages || [];
  var entity = useEntity();
  var langsComingSoon = site.langsComingSoon && site.langsComingSoon.split(',') || [];
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, showTitle && React.createElement(SiteMenuTitle, null, t('Language')), languages.map(function (lang) {
    var _a;
    var isActive = lang.iso === activeLang.iso;
    var isComingSoon = includes(langsComingSoon, lang.iso);
    var labelTemplate = template("<%= label %> ".concat(isComingSoon ? '(Coming Soon)' : ''));
    var label = labelTemplate({
      label: lang.menuLabel || lang.label
    });
    return React.createElement(My.Item, {
      isDisabled: isComingSoon,
      onClick: !isComingSoon && onItemClick,
      key: lang.id,
      patchLang: false,
      image: React.createElement(My.TextBubble, {
        size: 32
      }, (_a = lang.iso) === null || _a === void 0 ? void 0 : _a.toUpperCase()),
      href: entityLangPath(entity, lang),
      isActive: isActive,
      label: label
    });
  }));
});
LangMenu.cls = cls;
LangMenu.defaultProps = LangMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;